import Quill from 'quill'
import sanitizeHTML from '@/utils/quill-sanitize'

const Clipboard = Quill.import('modules/clipboard')

class SafeClipboard extends Clipboard {
  convert (html) {
    return super.convert(typeof html === 'string' ? sanitizeHTML(html) : html)
  }
}

export default SafeClipboard
